module.exports = __webpack_public_path__ + "iframe.5294d857.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/community_tabs/iframe.png
// module id = 1523
// module chunks = 0